<template>
  <button
    type="button"
    :disabled="disabled"
    class="cxm-Tile"
    :class="{ 'is-selected': isSelected, 'is-error': isError, '-FullWidth': fullWidth }"
    @click="(e) => $emit('click', e)"
  >
    <div
      v-if="channelAnonymous"
      class="cxm-Tile-Anonymous"
    >
      <div class="cxm-Tile-IconAnonymous">
        <Icon
          name="Anonymous"
        />
      </div>
    </div>
    <div
      v-if="iconName"
      class="cxm-Tile-Icon"
    >
      <Icon
        :name="iconName"
        :color="setColor"
      />
    </div>
    <div>{{ label }}</div>
  </button>
</template>

<script>
import Icon from '../Icon/Icon.vue';

export default {
  name: 'Tile',
  components: { Icon },
  props: {
    label: {
      type: String,
      default: '',
    },
    textTooltip: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    channelAnonymous: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    setColor() {
      if (this.disabled) {
        return this.$style.tileColorDisabled;
      } if (this.isSelected) {
        return this.$style.tileColorSelected;
      }
      return this.$style.tileColorPrimary;
    },
  },
};
</script>

<style scoped lang="scss">
.highlight {
  background-color: var(--track-color-white);
  border: var(--track-border-sm) solid var(--track-color-brand-primary-darkest);
  box-shadow: var(--track-shadow-sm);

  position: relative;
  color: var(--track-color-bluegray-80);
  font-weight: var(--track-font-weight-semibold);
}

.cxm-Tile {
  min-height: 104px;
  width: 100px;
  color: var(--track-color-bluegray-70);
  cursor: pointer;
  border-radius: var(--track-border-radius-sm);
  padding: var(--track-spacing-sm);
  background-color: var(--track-color-white);
  border: var(--track-border-sm) solid var(--track-color-bluegray-60);
  top: 0px;
  transition: all ease 0.2s;
  font-size: var(--track-font-size-xs);
  font-weight: var(--track-font-weight-medium);
  line-height: var(--track-line-height-compact);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  word-break: break-word;

  &.-FullWidth {
    width: 100%;
    padding: var( --track-spacing-md);
    position: relative;
  }

  &:hover {
    @extend .highlight;
    top: -2px;

  }
  &.is-selected {
    @extend .highlight;
  }

  &.is-selected .cxm-Tile-Icon{
    background: var(--track-color-brand-primary-lightest);
  }

  .cxm-Tile-Anonymous{
    position: absolute;
    right: 0;
    top: 0;
  }

  .cxm-Tile-IconAnonymous{
    background: var(--track-color-bluegray-10);
    border-radius: 0px 4px 0px 8px;
  }

  .cxm-Tile-Icon {
    background: var(--track-color-bluegray-10);
    width: var(--track-spacing-lg);
    height: var(--track-spacing-lg);
    border-radius: 100%;
    margin-bottom: var(--track-spacing-sm);
  }

  &:hover .cxm-Tile-Icon{
    background: var(--track-color-brand-primary-lightest);
  }

  &:disabled {
    position: static;
    color: var(--track-color-bluegray-40);
    border: var(--track-border-sm) solid var(--track-color-bluegray-40);
    box-shadow: none;
    cursor: not-allowed;
  }

  &:disabled .cxm-Tile-Icon {
    background: var(--track-color-bluegray-10);
  }

  .cxm-Tile-Icon svg {
    display: flex;
    margin: auto;
    align-items: center;
    height: 100%;
  }

  &.is-error {
    border-color: var(--track-color-negative-medium);
  }
}
</style>
<style module>
:export {
  tileColorDisabled: var(--track-color-bluegray-40);
  tileColorPrimary: var(--track-color-bluegray-60);
  tileColorSelected: var(--track-color-brand-primary-darkest);
}
</style>
